import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let has_admin = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.permissions.has_admin',
  })

  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })

  let boardsWhere = {
    _or: [
      // My boards: subscribed to, except my own private boards
      {
        subscribers: { user_id: { _eq: user_id } },
        _or: [{ created_by: { _neq: user_id } }, { type: { _neq: 'PRIVATE' } }],
      },
      // Other boards: public/hidden, not subscribed
      {
        type: { _in: has_admin ? ['PUBLIC', 'HIDDEN'] : ['PUBLIC'] },
        _not: { subscribers: { user_id: { _eq: user_id } } },
      },
      // Private boards: created by me
      {
        type: { _eq: 'PRIVATE' },
        created_by: { _eq: user_id },
      },
    ],
  }

  return {
    variables: {
      location_id,
      user_id,
      boards_where: boardsWhere,
    },
  }
}
